import { render, staticRenderFns } from "./proposedDocumentListDetail.vue?vue&type=template&id=b895e412&"
import script from "./proposedDocumentListDetail.vue?vue&type=script&lang=js&"
export * from "./proposedDocumentListDetail.vue?vue&type=script&lang=js&"
import style0 from "./proposedDocumentListDetail.vue?vue&type=style&index=0&id=b895e412&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports